import { Record } from 'immutable';

export const community = {
    id: null,
    isPending: false,
    error: null,
    data: null,
};

